import api from './api';
import * as types from './mutation-types';
import CommCodeModel from '../model/CommCodeModel';

export default {
	fetchProcesses_: ({ state, commit }, payload) => {
		return api
			.fetchProcesses(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				const { pagingInfo, resultList } = body;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: pagingInfo
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'processes',
						value: resultList
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPlants_: ({ state, commit }) => {
		return api
			.fetchPlants()
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const plants = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							plants
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	//공통 코드 조회
	getSyncFlagList_({ commit, rootState, rootGetters }) {
		return api
			.getCommonCdList({ plantCd: rootState.commonStore.user.plantCd, commCdType: 'SYNCFLAG' }) //USE_YN 공통 API 조회
			.then(res => {
				if (res.header.code === 0) {
					//API 응답이 정상일 경우
					const value = res.body.map(({ commCd, commCdName }) => ({ label: commCdName, value: commCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.DEFAULT_ASSIGN, { key: 'syncFlags', value }); //Select Box Options 값 Vuex에 저장
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//공통 코드 조회
	getDBInfoList_({ commit, rootState, rootGetters }) {
		return api
			.getCommonCdList({ plantCd: rootState.commonStore.user.plantCd, commCdType: 'DB_INFO' }) //USE_YN 공통 API 조회
			.then(res => {
				if (res.header.code === 0) {
					//API 응답이 정상일 경우
					const value = res.body.map(({ commCd, commCdName }) => ({ label: commCdName, value: commCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.DEFAULT_ASSIGN, { key: 'dbInfos', value }); //Select Box Options 값 Vuex에 저장
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPgmIds_: ({ state, commit }, payload) => {
		return api
			.fetchPgmIds(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							pgmIds: body.sort((a, b) => a.value - b.value)
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchSqlDetails_: ({ state, commit }, payload) => {
		return api
			.fetchSqlDetails(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				const sqlDetails = Array.isArray(body) && body.length > 0 ? body[0] : {};
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'sqlDetails',
						value: sqlDetails
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	saveSqlDetails_: ({ state, commit }, payload) => {
		return api
			.saveSqlDetails(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	}
};
